import { render, staticRenderFns } from "./FighterCategoryIndex.vue?vue&type=template&id=1529560a&lang=pug"
import script from "./FighterCategoryIndex.vue?vue&type=script&lang=js"
export * from "./FighterCategoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports